import { logger } from 'monitor';
import posthog from 'posthog-js';

import type { UserInfo } from '../types/userInfo';
import { initAnalytics } from './initAnalytics';

export const identifyUser = (userId: string, userInfo: UserInfo) => {
  logger.debug('Identifying analytics user', { userId, userInfo });

  if (!posthog.__loaded) {
    initAnalytics();
  }

  posthog.identify(userId, userInfo);
};
